import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import DataLoader from '../app/DataLoader'
import Image404 from '../img/404/not_found.png'

export default class NotFound404 extends PureComponent {
  render () {
    return (
      <DataLoader>
        <div className='not-found'>
          <div className='not-found__content'>
            <img className="not-found__image" src={Image404} alt="not_found"/>
            <p className='not-found__Heading'>Well, this is awkward...</p>
            <h3 className='not-found__info'>It doesn't seem like that page exists.</h3>
            <Link className='btn btn-primary' to='/app/dashboard'>
            {this.props.user ? 'Back To Dashboard' : 'Go back Home'} </Link>
          </div>
        </div>
      </DataLoader>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js